import script from "./ClientCabinetSignTab.vue?vue&type=script&setup=true&lang=js"
export * from "./ClientCabinetSignTab.vue?vue&type=script&setup=true&lang=js"

import "./ClientCabinetSignTab.vue?vue&type=style&index=0&id=101fbec8&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-101fbec8"]])

export default __exports__